export default "__VITE_ASSET__a1AZnR1H__"